export const stripNumbersAndSpecialChars = (str) => {
    const nonAlpha = /[^ A-Za-z`-]/g;
    return str.replace(nonAlpha, '');
};
/**
 * Capitalizes the first letter of a string
 * @param {string} txt - The text to capitalize
 * @param {boolean} allWords - Optional boolean to capitalize the first letter of each word. Ex BROWN FOX -> Brown Fox
 * @returns {string} The capitalized string
 */
export const capitalize = (txt, allWords = false) => {
    // Breaks down the string into an array of words, capitalizes the first letter of each word, and joins them back together
    if (allWords)
        return txt
            .split(' ')
            .map((word) => word?.[0]?.toUpperCase() + word?.slice(1).toLowerCase())
            .join(' ');
    // Capitalizes the first letter of the first word only
    return txt?.[0]?.toUpperCase() + txt?.slice(1)?.toLowerCase();
};
